import { render, staticRenderFns } from "./MultiPeoplePicker.vue?vue&type=template&id=e89535ca"
import script from "./MultiPeoplePicker.vue?vue&type=script&lang=ts"
export * from "./MultiPeoplePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports